module.exports = __webpack_public_path__ + "static/media/alert-warning.445e6ac6.wav";